module.exports = __webpack_public_path__ + "static/media/Loading_Animation.735494b6.gif";